import { useGetTopMenu1Categories, useGetTopMenus } from '@hts/features/libs';
import { EPageSubmenuType } from '@hts/shared/enums';
import { IGetStaticElementsResponse, IMappedSubmenuCategory } from '@hts/shared/types';
import { HtsButtonIcon, HtsTypography, HtslIcon } from '@hts/shared/ui';
import { SwipeableDrawer } from '@mui/material';
import { memo, useCallback } from 'react';
import styles from '../../../styles/Header/Mobile/AllSimchasMenu.module.scss';
import { ExpandedCategory } from './ExpandedCategory';

interface IAllSimchasMenuProps {
  isOpen: boolean;
  staticElements?: IGetStaticElementsResponse;
  onOpen: () => void;
  onClose: () => void;
  onCloseDrawer: () => void;
}

export const AllSimchasMenu: React.FC<IAllSimchasMenuProps> = memo(
  ({ isOpen, onClose, onOpen, onCloseDrawer, staticElements }) => {
    const { topMenu1 } = useGetTopMenus(staticElements?.menus);

    const categories = useGetTopMenu1Categories(topMenu1?.submenus, EPageSubmenuType.ALL_SIMCHAS);

    const onCloseDrawers = useCallback(() => {
      onCloseDrawer();
      onClose();
    }, [onClose, onCloseDrawer]);

    const renderCategory = useCallback(
      (category: IMappedSubmenuCategory, index: number) => (
        <ExpandedCategory
          key={`${category.id}-${index}`}
          category={category}
          onClose={onCloseDrawers}
        />
      ),
      [onCloseDrawers]
    );

    return (
      <SwipeableDrawer
        anchor="left"
        open={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        SlideProps={{ className: styles.slideContainer }}
      >
        <div className={styles.navigationContainer}>
          <HtsButtonIcon onClick={onClose}>
            <HtslIcon icon="keyboard-backspace-left" className={styles.backspaceIcon} />
          </HtsButtonIcon>
        </div>

        <div className={styles.contentContainer}>
          <HtsTypography variant="subtitle">All Simchas</HtsTypography>

          <ul className={styles.categoriesContainer}>{categories.map(renderCategory)}</ul>
        </div>
      </SwipeableDrawer>
    );
  }
);
